import moment from 'moment'
import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/i2Sales/swaps'

export default {
  namespaced: true,
  state: {
    loading: false,
    rates: {
      data: [],
      grandTotals: {
        swaps: 0,
        sales: 0,
        rates: 0,
      },
    },
    /* Filter Params */
    ratesParams: {
      sdate: `${moment().format('YYYY-MM')}-01`,
      edate: moment().format('YYYY-MM-DD'),
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    rates(state) {
      return state.rates
    },
    /* Filter Params */
    ratesParams(state) {
      return state.ratesParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_RATES(state, data) {
      state.rates = data
    },
    /* RESET MUTATIONS */
    RESET_RATES(state) {
      state.rates = {
        data: [],
        grandTotals: {
          swaps: 0,
          sales: 0,
          rates: 0,
        },
      }
    },
  },
  actions: {
    getRates({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_RATES')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/rates`, data)
        .then(response => {
          commit('SET_RATES', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
